import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import { SuggestedAutoLoanOffersView } from './SuggestedAutoLoanOffersView';
import React from 'react';
import { useLinkHandler } from 'hook/event.hook';
import { useViewModule, useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { SUGGESTED_AUTO_LOAN_OFFERS } from 'types/morph.pagePosition.constants';

const SuggestedAutoLoanOffers = props => {
  const onLinkClickCallback = useLinkHandler(props.eventHandler);

  const trackingAttributes = getViewModuleTrackingAttributes(
    SUGGESTED_AUTO_LOAN_OFFERS,
    props.modulePosition,
  );
  useViewModule(trackingAttributes);

  const seenPixel = useSeenModulePixel(trackingAttributes);

  return (
    <>
      <SectionContainer className="flex-column">
        <SuggestedAutoLoanOffersView
          pageName={props.pageName}
          autoLoanOffers={props.offers}
          currentLoanDetails={props.currentLoanDetails}
          onLinkClickCallback={onLinkClickCallback}
          seenPixel = {seenPixel}
          {...props}
        />
      </SectionContainer>
    </>
  );
};

export default SuggestedAutoLoanOffers;
